import React from 'react'
import Chart from 'react-apexcharts'
import ChartCard from './ChartCard'
import { formatCurrency } from '../mockData'

export default function ExpenseDonutChart({ data }) {
    const total = data.series.reduce((a, b) => a + b, 0)

    const options = {
        chart: {
            type: 'donut',
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        labels: data.labels,
        colors: data.colors,
        plotOptions: {
            pie: {
                donut: {
                    size: '65%',
                    labels: {
                        show: true,
                        name: { show: true, fontSize: '14px', color: '#64748B' },
                        value: {
                            show: true,
                            fontSize: '18px',
                            fontWeight: 700,
                            color: '#1E293B',
                            formatter: (val) => formatCurrency(val),
                        },
                        total: {
                            show: true,
                            label: 'Total',
                            fontSize: '13px',
                            color: '#64748B',
                            formatter: () => formatCurrency(total),
                        },
                    },
                },
            },
        },
        legend: {
            position: 'bottom',
            labels: { colors: '#64748B' },
        },
        tooltip: {
            y: { formatter: (val) => formatCurrency(val) },
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(1)}%`,
            style: { fontSize: '12px', fontWeight: 600 },
        },
        stroke: { width: 2, colors: ['#fff'] },
    }

    return (
        <ChartCard title="Composição de Despesas" subtitle="Distribuição por categoria">
            <Chart options={options} series={data.series} type="donut" height={350} />
        </ChartCard>
    )
}
